// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__7Fv2E","load5":"spinner_load5__T+iT1"};